import { OrderGetResponseType } from "@sellar-io/api-v2/types";
import { Alert } from "../alert/Alert";

export const BadPayerWarning = ({
  flaggedAsBadPayer,
  paymentType,
}: {
  flaggedAsBadPayer?: boolean;
  paymentType?: OrderGetResponseType["paymentType"];
}) => {
  if (!flaggedAsBadPayer || paymentType === "sellarCredit") return;
  return (
    <Alert
      className="w-full"
      type="warning"
      message="Warning: Pro-forma recommended for this customer"
    />
  );
};
